import React from 'react';
import styles from './FooterAguardandoAtendimento.module.css';
import Icon from '@mdi/react';
import { mdiAccountClock, mdiHeadset } from '@mdi/js';
import Botao from '@/components/Botao';

type FooterAguardandoAtendimento = {};

const FooterAguardandoAtendimento = ({ }: FooterAguardandoAtendimento) => {
    return (
        <div className={styles[`footer-status-aguardando-atendimento`]}>
            <div style={{ fontWeight: '600', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                <Icon path={mdiAccountClock} size="20px" />
                Aguardando atendimento
            </div>
            <div>
                Clique em <div style={{ padding: '1rem', display: 'inline-flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }} > <Icon path={mdiHeadset} size={1} /> Atender </div> (acima dos chats) para atender os clientes!
            </div>
        </div>
    );
};

export default FooterAguardandoAtendimento;
